import RequestAbstract from "../abstract";

export default class PublicTgBots extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-tg-bots";
    }

}
